import styles from '../styles/GroupTwo.module.css'
import { AiOutlineNotification, AiFillCaretDown } from 'react-icons/ai'
import { FiMessageCircle } from 'react-icons/fi'
export default function LogedSection({ usersex }) {
  return (
    <>
      <div className={styles.question}>
        <button>Criar pergunta</button>
      </div>
      <div className={styles.notifications}>
        <span>
          
          <AiOutlineNotification />
        </span>
      </div>
      <div className={styles.messages}>
        <span>
          
          <FiMessageCircle />
        </span>
      </div>
      <div className={styles.profile}>
        <img src={`./${usersex}.png`} alt='user pic' />
        <AiFillCaretDown/>
      </div>
    </>
  )
}